import { ele } from "cables-shared-client";
import api from "../../api.js";
import web from "../../index.js";
import PatchLists from "../../patchlists.js";

export default class PagePatchlistEdit
{
    constructor(targetElement)
    {
        this.patchLists = new PatchLists();
        const userTab = ele.byId("collaboration");
        const autoSuggests = userTab.querySelectorAll("[data-autosuggest]");
        web.initializeAutosuggestsFromApi(autoSuggests);
    }

    inviteListUser(button)
    {
        web.buttons.startSavingAnimButton(button);
        const name = ele.byId("list-inviteuser").dataset.autosuggestValue || ele.byId("list-inviteuser").value;
        const listId = ele.byId("list-id").value;
        const fullAccess = ele.byId("inviteWritePermission").value;
        let readOnly = (fullAccess !== "true");

        api.post(
            "patchlists/" + listId + "/members/" + name,
            {
                "readOnly": readOnly
            },
            (res) =>
            {
                web.buttons.stopSavingAnimButton();
                document.location.reload();
            },
            (res) =>
            {
                web.buttons.stopSavingAnimButton(button, false);
                const errorEle = ele.byId("invite-error");
                if (errorEle)
                {
                    const target = errorEle.querySelector(".warn-hint");
                    if (target) target.innerText = "- adding not possible: \"" + res.msg + "\"";
                    ele.show(errorEle);
                }
            });
    }

    removeListMember(el)
    {
        let r = confirm("are you sure? remove from list?");

        if (r)
        {
            const userId = el.dataset.userid;
            const listId = ele.byId("list-id").value;
            api.delete(
                "patchlists/" + listId + "/members/" + userId,
                {},
                (res) =>
                {
                    web.buttons.stopSavingAnimButton(el, false);
                    document.location.reload();
                },
                (res) =>
                {
                    web.buttons.stopSavingAnimButton(el, false);
                    const errorEle = ele.byId("invite-error");
                    if (errorEle)
                    {
                        const target = errorEle.querySelector(".warn-hint");
                        if (target) target.innerText = "- removal not possible: \"" + res.msg + "\"";
                        ele.show(errorEle);
                    }
                });
        }
    }

    makeListOwner(el)
    {
        const userId = el.dataset.userid;
        const listId = ele.byId("list-id").value;
        api.post(
            "patchlists/" + listId + "/owner",
            {
                "userId": userId
            },
            (res) =>
            {
                web.buttons.stopSavingAnimButton(el, false);
                document.location.reload();
            },
            (res) =>
            {
                web.buttons.stopSavingAnimButton(el, false);
                const errorEle = ele.byId("invite-error");
                if (errorEle)
                {
                    const target = errorEle.querySelector(".warn-hint");
                    if (target) target.innerText = "- removal not possible: \"" + res.msg + "\"";
                    ele.show(errorEle);
                }
            });
    }

    setListPermissions(value, userId, cb = false)
    {
        let fullAccess = (value === "fullAccess");
        const listId = ele.byId("list-id").value;
        api.put("patchlists/" + listId + "/" + userId + "/permissions/write/" + fullAccess, {}, () =>
        {
            if (cb)
            {
                cb();
            }
            else
            {
                document.location.reload();
            }
        });
    }

    addTeam(teamId)
    {
        const listId = ele.byId("list-id").value;
        const errorEle = ele.byId("invite-error");
        if (teamId)
        {
            api.post("patchlists/" + listId + "/teams/" + teamId, {}, (response) =>
            {
                web.buttons.stopSavingAnimButton();
                document.location.reload();
            }, (e) =>
            {
                web.buttons.stopSavingAnimButton(false, false);
                if (errorEle)
                {
                    const target = errorEle.querySelector(".warn-hint");
                    if (target) target.innerText = "- adding team not possible: \"" + e.msg + "\"";
                    ele.show(errorEle);
                }
            });
        }
        else
        {
            web.buttons.stopSavingAnimButton(false, false);
            if (errorEle)
            {
                const target = errorEle.querySelector(".warn-hint");
                if (target) target.innerText = "- Unknown team or insufficient permissions";
                ele.show(errorEle);
            }
        }
    }

    removeTeam(teamId)
    {
        const listId = ele.byId("list-id").value;
        api.delete("patchlists/" + listId + "/teams/" + teamId, {}, (response) =>
        {
            document.location.reload();
        }, (e) =>
        {
            web.buttons.stopSavingAnimButton(false, false);
            const errorEle = ele.byId("invite-error");
            if (errorEle)
            {
                const target = errorEle.querySelector(".warn-hint");
                if (target) target.innerText = "- removal not possible: \"" + e.msg + "\"";
                ele.show(errorEle);
            }
        });
    }

    removeOp(listId, opId)
    {
        let r = confirm("are you sure? remove op?");
        if (r)
        {
            api.delete("patchlists/" + listId + "/ops/" + opId, {}, (response) =>
            {
                document.location.reload();
            }, (e) =>
            {
                web.buttons.stopSavingAnimButton(false, false);
                const errorEle = ele.byId("patch-error");
                if (errorEle)
                {
                    const target = errorEle.querySelector(".warn-hint");
                    if (target) target.innerText = "- removal not possible: \"" + e.msg + "\"";
                    ele.show(errorEle);
                }
            });
        }
    }

    deletePatchlist(id, name, successUrl = "/mypatchlists")
    {
        if (confirm("Really delete " + name + " ?"))
        {
            api.delete(
                "patchlists/" + id,
                {},
                (res) =>
                {
                    if (successUrl)
                    {
                        document.location.href = successUrl;
                    }
                    else
                    {
                        const successMsg = ele.byId("successmsg");
                        if (successMsg)
                        {
                            ele.show(successMsg);
                        }
                        else
                        {
                            document.location.reload();
                        }
                    }
                },
                (res) =>
                {
                    const errorMsg = ele.byId("errormsg");
                    if (errorMsg)
                    {
                        const msgEl = errorMsg.querySelector(".error");
                        msgEl.innerText = res.msg;
                        ele.show(errorMsg);
                    }
                });
        }
    }
}
